/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Reply_SendInputs */

const cs_messages_reply_send = /** @type {(inputs: Messages_Reply_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat odpověď`)
};

const en_messages_reply_send = /** @type {(inputs: Messages_Reply_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send reply`)
};

/**
* | output |
* | --- |
* | "Send reply" |
*
* @param {Messages_Reply_SendInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_reply_send = /** @type {((inputs?: Messages_Reply_SendInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Reply_SendInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_reply_send(inputs)
	return cs_messages_reply_send(inputs)
});